(function(){
    'use strict'

    angular
    .module('app.accionesPersonal')
    .controller('AccionesPersonal', AccionesPersonal);

    AccionesPersonal.$inject = ['$q', '$window', '$animationsSrv', 'AccionesPersonalService', 'TiposAccionPersonalService', 'DepartamentosService', 'logger', '$location', 'UserInfoService', 'apiSettings'];

    function AccionesPersonal($q, $window, $animationsSrv, AccionesPersonalService, TiposAccionPersonalService, DepartamentosService, logger, $location, UserInfoService, apiSettings) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.accionesPersonal = [];
        vm.title = 'AccionesPersonal';
        vm.tipoAcciones = [];
        vm.departamentos = [];

        vm.busqueda = {
            empleadoDepartamentoId: -1,
            empleadoNombre: '',
            empleadoId: '',
            tipoAccion: -1,
            companiaId: UserInfoService.getCompaniaId()
        };

        vm.goToEdit = function(accionPersonal){
            
            var path = '/editar-accion-personal/';

            if(accionPersonal){
                $location.path(path + accionPersonal.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        var promiseDepartamento = getDepartamentos();
        var promiseTipoAccion = getTipoAcciones();

        CargarDatos();

        function CargarDatos(){
            $q.all([promiseDepartamento, promiseTipoAccion]).then(function(){

                getAll();
            }); 
        };

        function getAll(){

            var promise = AccionesPersonalService.getAll();

            promise
            .then(function(accionesPersonal){
                vm.accionesPersonal = accionesPersonal;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los accionesPersonal.');
                        break;
                }
            });
        };

        vm.search = function(){

            var promise = AccionesPersonalService.search(vm.busqueda)
            .then(function(accionesPersonal){
                vm.accionesPersonal = accionesPersonal.data;
            })
            .catch(function(error){
                $logger.error('Error al obtener las acciones de personal.');
            }); 
        
        };

        vm.clearCriteria = function(){
            vm.busqueda.empleadoId = '';
            vm.busqueda.empleadoNombre = '';
            vm.busqueda.empleadoDepartamentoId = -1;
            vm.busqueda.tipoAccion = -1 
        };

        function getDepartamentos(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        function getTipoAcciones(){
            var promise = TiposAccionPersonalService.getAll(UserInfoService.getCompaniaId())
            .then(function(tipos){
                vm.tipoAcciones = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de acciones.');
            }); 
            
            return promise;
        };

        vm.delete = function(accionPersonal){
            var promise = AccionesPersonalService.remove(accionPersonal);
            
            promise
            .then(function(response){
                vm.accionesPersonal = vm.accionesPersonal.filter(function(g) {
                    return g.id !== accionPersonal.id;
                });
                logger.success('Accion Personal eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Accion Personal');
                        break;
                }
                
            });   
        };

        vm.openAccionPersonal = function(accion){
            var url = apiSettings.apiBaseUrl + '/' + accion.pdfLocation;
            $window.open(url, '_blank');
        };

    }
})();